module.exports = __webpack_public_path__ + "img/require-tickets-event.bb8b09b8.svg";